import * as React from 'react';
import { SearchableSelect } from './searchable-select';

interface TimezoneSelectProps {
	value: string;
	onValueChange: (value: string) => void;
}

interface TimezoneOption {
	value: string;
	label: string;
}

export function TimezoneSelect({ value, onValueChange }: TimezoneSelectProps) {
	const timezones = React.useMemo(() => {
		return Intl.supportedValuesOf('timeZone').map(
			(zone): TimezoneOption => ({
				value: zone,
				label: zone.replace(/_/g, ' '),
			})
		);
	}, []);

	return (
		<div className='space-y-2'>
			<label className='text-sm font-medium'>Timezone</label>
			<SearchableSelect<string>
				options={timezones}
				value={value}
				onValueChange={onValueChange}
				placeholder='Select timezone...'
			/>
		</div>
	);
}
